import dayjs from 'dayjs';

export const convertGeneralModel = data => {

  return ({
    date_from: data.beginDate ? dayjs(data.beginDate).format('YYYY-MM-DD') : undefined,
    date_to: data.endDate ? dayjs(data.endDate).format('YYYY-MM-DD') : undefined,
    prev_date_from: (data.withDiff && data.beginDatePrev) ? dayjs(data.beginDatePrev).format('YYYY-MM-DD') : undefined,
    prev_date_to: (data.withDiff && data.endDatePrev) ? dayjs(data.endDatePrev).format('YYYY-MM-DD') : undefined,
    login: data.search || undefined,
  })
}
